import React, {ComponentType} from 'react';

import type {FC} from 'react';
import type {RoleDetailsProps} from '@touchnet/user-management';
import RoleDetailsWithScopes from "~/components/pages/user-mgmt/role-details-with-scopes";
import {ErpRoles} from "~/components/pages/user-mgmt/types/urps-types";
import ErpUiAdminDetails from "~/components/pages/user-mgmt/roles/role-details/erp-ui-admin-details";


export const RoleDetailsProvider: FC<RoleDetailsProps> = (props: RoleDetailsProps) => {
    const {roleCode, scopes} = props;
    let DetailsComponent: ComponentType;

    switch (roleCode) {
        case ErpRoles.ERP_ADMIN:
            DetailsComponent = ErpUiAdminDetails;
            break;

        default:
            DetailsComponent = React.Fragment;
            break;
    }

    if (scopes !== null) {
        return (
            <RoleDetailsWithScopes
                DetailsComponent={DetailsComponent}
                roleCode={roleCode}
                scopes={scopes}
            />
        );
    }

    return (<DetailsComponent />);
};

export default RoleDetailsProvider;
